import React from 'react';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';
import { MyBadges, Props as WidgetProps } from './MyBadges';
import reduxConnectContainer from './MyBadges.container';
import EmptyState from '../../EmptyState';
import WidgetBoxWide, {
  Props as WidgetBoxWideProps,
} from '../_partials/WidgetBoxWide';
import getStatLine from '../../../utils/getStatLine';
import { URLS } from '@wix/da-url';

import s from './MyBadges.scss';

export interface Props {
  currentUser: PapiUser;
  hasMoreBadgeActivity: boolean;
  fetchMoreBadgeActivity: () => void;
  isFetchingBadgeActivity: boolean;
  profileOwnerUser: PapiUser;
  isEmpty: boolean;
}

class MyBadgesInExpandedWidgetContainer extends React.Component<
  Props & WidgetProps & WidgetBoxWideProps & WithTranslation
> {
  render() {
    const {
      id,
      subHeader,
      headerExtraElementsOnMobile,
      isHeaderStickyOnMobile,
      hasMoreBadgeActivity,
      fetchMoreBadgeActivity,
      isFetchingBadgeActivity,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      widgetBoxClassName,
      parentRef,
      isEmpty,
      section,
      zone,
      ...props
    } = this.props;

    return (
      <WidgetBoxWide
        section={section}
        zone={zone}
        moduleId={props.moduleId}
        id={id}
        header={props.t!('widgets.badges_activity.header')}
        count={props.totalReceived}
        subHeader={getStatLine(props.t!, 'badges', props.totalReceived)}
        isHeaderStickyOnMobile={isHeaderStickyOnMobile}
        headerExtraElementsOnMobile={headerExtraElementsOnMobile}
        hasMore={hasMoreBadgeActivity}
        fetchMore={fetchMoreBadgeActivity}
        isFetching={isFetchingBadgeActivity}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        className={widgetBoxClassName}
        parentRef={parentRef}
        isEmpty={isEmpty}
        emptyView={
          props.isCurrentUserProfileOwner ? (
            <EmptyState
              view="small"
              className={s['empty-state']}
              title={props.t!('widgets.badges_activity.empty.title.owner')}
              subtitle={props.t!('widgets.badges_activity.empty.subtitle.owner')}
              withButton
              buttonLabel={props.t!('widgets.badges_activity.empty.CTALabel.owner')}
              onButtonClick={this.navigateToBrowse}
            />
          ) : (
            <EmptyState
              view="small"
              className={s['empty-state']}
              title={props.t!('widgets.badges_activity.empty.title.visitor', {
                username: props.profileOwnerUser.username,
              })}
              subtitle={props.t!('widgets.badges_activity.empty.subtitle.visitor', {
                username: props.profileOwnerUser.username,
              })}
            />
          )
        }
      >
        <MyBadges {...props} />
      </WidgetBoxWide>
    );
  }

  navigateToBrowse() {
    window.location.replace(URLS.ROOT);
  }
}

const enhance = compose(reduxConnectContainer, withTranslation());

export default enhance(MyBadgesInExpandedWidgetContainer);
